import "../../../src/App.css";
import LeadSource from "../../components/LeadSource/LeadSource";
import AddLeadSource from "../../components/AddLeadSource/AddLeadSource";
import LeadSourceList from "../../components/LeadSourceList/LeadSourceList";
import React, { useState, useEffect } from "react";
import axios from "axios";
import MasterTopButtons from "../../components/MasterTopButtons/MasterTopButtons";
import PaginationLink from "../../components/Pagination/Pagination";
import MiniDrawer from "../../components/MiniDrawer/MiniDrawer";
import SearchIcon from "@mui/icons-material/Search";
import Wrapper from "../../components/UI/Wrapper";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

function LeadSourceMaster() {
  const [leadDetailResponse, setLeadDetailResponse] = useState(null);
  const [openProfile, setOpenProfile] = useState(false);
  const [openAddProfile, setOpenAddProfile] = useState(false);
  const [filterCityData, setFilterCityData] = useState(false);
  const [leadId, setLeadId] = useState();
  const baseAPI = process.env.REACT_APP_API_URL;
  const title = "Add LeadSource";
  const heading = "Lead Source List";

  function tokenStorage(){
    const storedToken = JSON.parse(localStorage.getItem("token"));
    //console.log(storedToken);

    if (storedToken) {
      axios
        .get(
          `${baseAPI}adminget/GETLeadSource?LeadSourceID=0`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          //console.log(response.data.data);
          setLeadDetailResponse(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  };

  useEffect(() => {
    tokenStorage();
  }, []);

  const GetId = (param) => {
    setLeadId(param);
  };

  return (
    <>
      <div className="d-flex flex-row app">
        <MiniDrawer />
        <div
          className="container-fluid"
          style={{ padding: "4rem 1rem 1rem 1rem", backgroundColor: "#F4F4F4" }}
        >
          <div
            className="d-flex flex-column w-100"
            style={{ backgroundColor: "#F4F4F4" }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <div>
                <h1 style={{ fontSize: "24px", marginBottom: "2rem" }}>
                  Lead Source List| <HomeOutlinedIcon />{" "}
                  <span style={{ fontSize: "20px" }}>&gt; Lead List</span>
                </h1>
              </div>
              <div style={{ width: "8rem" }}>
                <select className="form-control" name="country">
                  <option value="0">INDIA </option>
                  <option value="1">DUBAI </option>
                </select>
              </div>
            </div>
            <div>
              <Wrapper className="ViewLeadDetails">
                <MasterTopButtons
                  title={title}
                  heading={heading}
                  setOpenAddProfile={setOpenAddProfile}
                  openAddProfile={openAddProfile}
                  setOpenProfile = {setOpenProfile}
                  setFilterCityData = {setFilterCityData}
                  filterCityData = {filterCityData}
                />
                {openAddProfile ? <AddLeadSource tokenStorage = {tokenStorage} openAddProfile = {openAddProfile} setOpenAddProfile = {setOpenAddProfile} /> : null}
                {openProfile ? <LeadSource tokenStorage = {tokenStorage} openProfile = {openProfile} setOpenProfile = {setOpenProfile} leadId={leadId} /> : null}
                <LeadSourceList
                  leadDetailResponse={leadDetailResponse}
                  setOpenProfile={setOpenProfile}
                  openProfile={openProfile}
                  GetId={(param) => GetId(param)}
                  openAddProfile = {openAddProfile} 
                  setOpenAddProfile = {setOpenAddProfile}
                />
                <PaginationLink />
              </Wrapper>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default LeadSourceMaster;
